<template>
  <Banner />
  <router-view />
</template>

<script lang="ts">
import Banner from './components/Banner.vue'
import MainContent from './components/MainContent.vue'

export default {
  name: 'App',
  components: { Banner, MainContent},
  data() {
    return {
      title: 'Testing'
    }
  },
  mounted() {
    document.title = 'Crafts Code'
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
